let apihost = "";
let wshost = "";
try {
	//console.log(window.location.hostname);
	//console.log(window.location.port);
	// eslint-disable-next-line eqeqeq
	let protocol = window.location.protocol == "https:" ? "https:" : "http:";
	// eslint-disable-next-line eqeqeq
	let wsprotocol = window.location.protocol == "https:" ? "wss:" : "ws:";
	apihost = window.location.port
		? `${protocol}//${window.location.hostname}:${window.location.port}`
		: `${protocol}//${window.location.hostname}`;
	wshost = window.location.port
		? `${wsprotocol}//${window.location.hostname}:${window.location.port}`
		: `${wsprotocol}//${window.location.hostname}`;
} catch {
	console.log("URL Error");
}

export const APIHOST = apihost;
export const WSHOST = wshost;


//EndPoints Users
export const POSTLOGIN = `${APIHOST}/api/v1/auth/login`;

//EndPoint 
export const ORDEROPENORCLOSED = `${APIHOST}/api/v1/extranet/`;
export const ORDERSDELIVERIES = `${APIHOST}/api/v1/extranet/getdeliveriesbyfacliid/json?facliid=`;

//DOwnload Orders Open and CLOSED CSV
export const DOWNLOADORDERSOPEN = `${APIHOST}/api/v1/extranet/orders-open/csv?companyid=`
export const DOWNLOADORDERSOPCLOSED = `${APIHOST}/api/v1/extranet/orders-closed/csv?companyid=`
export const STOCKGET = `${APIHOST}/api/v1/extranet/stock/`

//DOWNLOAD FILE CSV STOCK
export const DOWNLOADSTOCKMP = `${APIHOST}/api/v1/extranet/stock/mp/csv?companyid=`;
export const DOWNLOADSTOCKPRODACABADO = `${APIHOST}/api/v1/extranet/stock/prodacabado/csv?companyid=`;
export const DOWNLOADSTOCKCOMPPART = `${APIHOST}/api/v1/extranet/stock/comppart/csv?companyid=`;

//Props App
export const GETPROPSAPP = `${APIHOST}/api/v1/base/info`;

// GET REPORT STOCK and DOWNLOAD CSV
export const GETREPORTSTOCK = `${APIHOST}/api/v1/extranet/stock/report/json?companyid=`;
export const DOWNLOADREPORTSTOCK = `${APIHOST}/api/v1/extranet/stock/report/csv?companyid=`;

export const INFOETIQUETA = `${APIHOST}/api/v1/extranet/info/vol`;
export const FULLINFO = `${APIHOST}/api/v1/extranet/info/full_vol`;

export const LITEINFO = `${APIHOST}/api/v1/extranet/info/vol_lite`;
export const DOWNLOADVOLCSV = `${APIHOST}/api/v1/extranet/info/full_vol/csv`;

export const GETEXPEDITIONGUIDE = `${APIHOST}/api/v1/extranet/expedition_guide/byclient?client_id=`
export const GETEXPEDITIONGUIDEINFO = `${APIHOST}/api/v1/extranet/expedition_guide_info/by_expedition_guide?client_id=`
export const INFO_BY_EXPEDITION_GUIDE = `${APIHOST}/api/v1/extranet/info/by_expedition_guide?expedition_guide=`
export const INFO_BY_EXPEDITION_GUIDE_CSV = `${APIHOST}/api/v1/extranet/info/by_expedition_guide/csv?expedition_guide=`

export const GETSHIPMANIFEST = `${APIHOST}/api/v1/extranet/shipment_manifest/byclient?client_id=`
export const GETSHIPMANIFESTINFO = `${APIHOST}/api/v1/extranet/shipment_manifest_info/by_shipment_manifest?client_id=`
export const INFO_BY_SHIPMENT_MANIFEST = `${APIHOST}/api/v1/extranet/info/by_shipment_manifest?shipment_manifest=`
export const INFO_BY_SHIPMENT_MANIFEST_CSV = `${APIHOST}/api/v1/extranet/info/by_shipment_manifest/csv?shipment_manifest=`


// Anexos GDoc (Tipos 40 e 50)
export const ATTACHMENTS_BASE = `${APIHOST}/api/v1/extranet/attachments/by_client/`;


